import { render, staticRenderFns } from "./ListProviders.vue?vue&type=template&id=04a5dfe4&"
import script from "./ListProviders.vue?vue&type=script&lang=js&"
export * from "./ListProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports